// extracted by mini-css-extract-plugin
export default {"container":"create_container__H6xmq","header":"create_header__4-+Sr","title":"create_title__PpZaT"};